import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Aux from '../../hoc/Aux';
import { useForm, Controller } from 'react-hook-form';
import * as actions from '../../store/actions/index';
import Select from 'react-select'
import * as modalTypes from '../Modals/modalTypes';
import {Link } from "react-router-dom";
import useCustomTranslation from '../../hooks/useCustomTranslation';
import { useTranslation } from 'react-i18next';

const register = (props) => {

  const ct = useCustomTranslation();
  const dispatch = useDispatch();
  const { register, setError, errors, handleSubmit, control, getValues } = useForm();
  const [registrationResult, setRegistrationResult] = useState([]);
  const { t } = useTranslation();

  const showDatenschutzModalHandler = () => {
    const modalProps = {open: true};
    const modalType = modalTypes.MODAL_SHOW_DATENSCHUTZ;
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const showTermsOfUseModalHandler = () => {
    const modalProps = {open: true};
    const modalType = modalTypes.MODAL_SHOW_TERMS_OF_USE;
    dispatch(actions.showModal({ modalProps, modalType }));
  }


  const onSubmit = data => {
    data = {...data, country: Object(data.country).code, contactType: Object(data.contactType).code}
    dispatch( actions.createAccount(data) ).then( (res) => {
      (res && res.errors)? errorHandling(res.errors) : setRegistrationResult(true)
    });
  } ;

  const intialValues = {
    firstName: "",
    lastName: "",
    company: "",
    branch: "",
    position: "",
    street: "",
    zipcode: "",
    city: "",
    country: "",
    phone: "",
    email: "",
    password: "",
    contactType: "",
    agb: false,
    question: ""
  };

  const countryOptions = () => actions.availableCountries.map( x => { return { code: x.toLowerCase(), label:  ct('countryname_' + x) }} )
  const contactTypeOptions = () => actions.availableContactTypes.map( x => { return { code: x.toLowerCase(), label:  ct('user.contact_type.' + x) }} )

  const errorHandling = (e) => {
    if ( Array.isArray(e['email']) ) {
      setError("email", {
              type: "manual",
              message: ct('form.register.errors.email.' + e['email'][0]['error'] )
            });
    }
    if ( Array.isArray(e['password']) ) {
      setError("password", {
              type: "manual",
              message: ct('form.register.errors.password.' + e['password'][0]['error'] )
            });
    }
  }

  const fieldClassName = (error) => {
    return (error)? "form-control is-invalid" : "form-control"
  }

  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName])?
       <div className="invalid-feedback">
          { ct('form.register.errors.' + fieldName + '.required') }
        </div> : null
  }



  return (
  <Aux>
    <div className="main-container">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-lg-11 col-xl-10">
            { (registrationResult === true)?
              <div className="page-header">
  							<h1>{ ct('sign_up.success.headline') }</h1>
                  <div className="card " style={{marginTop: "20px", border: "none"}}>
                    <div className="card-body">
                      <p className="lead" >{ ct('sign_up.success.text') }</p>
                    </div>
                    <div className="row justify-content-end">
                      <Link className="btn btn-primary btn-project" to="/wizard" style={{marginTop: "10px"}}>{ ct('sign_up.success.link_to_product_selector') }</Link>
                    </div>
                  </div>
  						</div>
              :

            <Aux>
						<div className="page-header">
							<h1>{ ct('sign_up.headline') }</h1>

						</div>
										<div className="row justify-content mt-5 projectdetails-left">
											<div className="col-xl-8 col-lg-9 projectdetails-right">
												<div className="card">
													<div className="card-body">
														<div className="tab-content">
															<div className="tab-pane fade show active" role="tabpanel" id="userdata">
																<h4>{ ct('sign_up.subheadline') }</h4>
                                  <form onSubmit={handleSubmit(onSubmit)}>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.first_name.label') }</label>
                											<div className="col">
                                        <input
                                          className={fieldClassName(errors.firstName)}
                                          name="firstName"
                                          defaultValue={intialValues.firstName}
                                          ref={register({ required: false })}
                                        />
                                      { errorMessage(errors, 'firstName') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.last_name.label') }*</label>
                											<div className="col">
                												<input
                                          className={fieldClassName(errors.lastName)}
                                          name="lastName"
                                          defaultValue={intialValues.lastName}
                                          ref={register({ required: true})} />
                                        { errorMessage(errors, 'lastName') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.company.label') }</label>
                											<div className="col">
                												<input
                                          className={fieldClassName(errors.company)}
                                          name="company"
                                          defaultValue={intialValues.company}
                                          ref={register({ required: false})} />
                                        { errorMessage(errors, 'company') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.branch.label') }</label>
                											<div className="col">
                                        <input
                                          className={fieldClassName(errors.branch)}
                                          name="branch"
                                          defaultValue={intialValues.branch}
                                          ref={register({ required: false})} />
                                        { errorMessage(errors, 'branch') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.position.label') }</label>
                											<div className="col">
                                        <input
                                          className={fieldClassName(errors.position)}
                                          name="position"
                                          defaultValue={intialValues.position}
                                          ref={register({ required: false})} />
                                        { errorMessage(errors, 'position') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.street.label') }</label>
                											<div className="col">
                                        <input
                                          className={fieldClassName(errors.street)}
                                          name="street"
                                          defaultValue={intialValues.street}
                                          ref={register({ required: false})} />
                                        { errorMessage(errors, 'street') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.zipcode.label') }</label>
                											<div className="col">
                                        <input
                                          className={fieldClassName(errors.zipcode)}
                                          name="zipcode"
                                          defaultValue={intialValues.zipcode}
                                          ref={register({ required: false})} />
                                        { errorMessage(errors, 'zipcode') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.city.label') }</label>
                											<div className="col">
                                        <input
                                          className={fieldClassName(errors.city)}
                                          name="city"
                                          defaultValue={intialValues.city}
                                          ref={register({ required: false})} />
                                        { errorMessage(errors, 'city') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.country.label') }</label>
                											<div className="col">
                                        <Controller
                                            as={Select}
                                            placeholder={ ct('sign_up.form.country.placeholder') }
                                            defaultValue=""
                                            options={countryOptions()}
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.code}
                                            value={countryOptions().find(o => o.code === getValues("country"))}
                                            onChange={([option]) => option.code}
                                            name="country"
                                            register={register}
                                            rules={{ required: false }}
                                            control={control}
                                            styles={
                                              (errors.country)?
                                              { control: (provided, { isFocused }) => ({
                                                  ...provided,
                                                  border: "1px solid red",
                                                  boxShadow: "0",
                                                  fontSize: ".875rem",
                                                  ':hover': { border: "1px solid red" }})
                                              } : { control: (provided, { isFocused }) => ({
                                                  ...provided,
                                                  boxShadow: "0",
                                                  fontSize: ".875rem",
                                                  border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                                                  ':hover': { border: "1px solid #dee2e6" }})
                                              }}
                                          />

                                        { (errors.country)?
                                              <div className="invalid-feedback" style={{display: "block"}}>
                                                 { ct('form.register.errors.country.required') }
                                               </div> : null
                                           }
                											</div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.phone.label') }</label>
                											<div className="col">
                                        <input
                                          className={fieldClassName(errors.phone)}
                                          name="phone"
                                          defaultValue={intialValues.phone}
                                          ref={register({ required: false})} />
                                        { errorMessage(errors, 'phone') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.email.label') }*</label>
                											<div className="col">
                                        <input
                                          className={(errors.email)? "form-control is-invalid" : "form-control"}
                                          name="email"
                                          defaultValue={intialValues.email}
                                          ref={register({ required: true})} />
                                         { (errors.email)?
                                             <div className="invalid-feedback">
                                                {errors.email.message}
                                              </div> : null
                                          }
                                          { errors.email && !errors.email.message && errorMessage(errors, 'email') }
                                      </div>
                										</div>
                										<div className="form-group row align-items-center">
                											<label className="col-3">{ ct('sign_up.form.contact_type.label') }</label>
                											<div className="col">


                                        <Controller
                                            as={Select}
                                            placeholder={ ct('sign_up.form.contact_type.label') }
                                            defaultValue={contactTypeOptions().find(o => o.code === intialValues.contactType)}
                                            options={contactTypeOptions()}
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.code}
                                            value={contactTypeOptions().find(o => o.code === getValues("contactType"))}
                                            onChange={([option]) => option.code}
                                            name="contactType"
                                            register={register}
                                            rules={{ required: false }}
                                            control={control}
                                            styles={
                                              (errors.country)?
                                              { control: (provided, { isFocused }) => ({
                                                  ...provided,
                                                  border: "1px solid red",
                                                  boxShadow: "0",
                                                  fontSize: ".875rem",
                                                  ':hover': { border: "1px solid red" }})
                                              } : { control: (provided, { isFocused }) => ({
                                                  ...provided,
                                                  boxShadow: "0",
                                                  fontSize: ".875rem",
                                                  border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                                                  ':hover': { border: "1px solid #dee2e6" }})
                                              }}
                                          />


                											</div>
                										</div>
                                    <div className="form-group row align-items-center">
                                      <label className="col-3">{ ct('sign_up.form.password.label') }*</label>
                                      <div className="col">
                                        <input
                                          type="password"
                                          className={fieldClassName(errors.password)}
                                          name="password"
                                          defaultValue={intialValues.password}
                                          ref={register({ required: true, minLength: 8})} />
                                           { (errors.password)?
                                               <div className="invalid-feedback">
                                                  {errors.password.message}
                                                </div> : null
                                            }
                                            { errorMessage(errors, 'password') }
                                      </div>
                                    </div>

                                    { (errors.agb)?
                                      <div className="form-group row align-items-center">
                                        <label className="col-3"></label>
                                        <div className="col">
                                          <div className="alert alert-danger" role="alert">
                                          { ct('form.register.errors.agb.required') }
                                           </div>
                                        </div>
                                      </div>: null

                                     }

                                    <div className="form-group row align-items-center">
                                      <label className="col-3"></label>
                                      <div className="col">
                                        <div className="form-group">
                                          <div className="custom-control custom-checkbox custom-checkbox-switch">
                                            <input
                                              id="notify-1"
                                              type="checkbox"
                                              className="custom-control-input"
                                              name="agb"
                                              defaultValue={intialValues.agb}
                                              ref={register({ required: true })}
                                              />
                                            <label className="custom-control-label" htmlFor="notify-1"> { ct('sign_up.form.agb.text_before') } <button className="ButtonLink" onClick={showTermsOfUseModalHandler}>{ ct('sign_up.form.agb.link_to_terms_of_use') }</button> { ct('sign_up.form.agb.text_between') } <button className="ButtonLink" onClick={showDatenschutzModalHandler}>{ ct('sign_up.form.agb.link_to_privacy') }</button> { ct('sign_up.form.agb.text_closing') }</label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="form-group row align-items-center">
                											<label className="col-3"></label>
                											<div className="col">
                                        <input
                                          className={fieldClassName(errors.question)}
                                          name="question"
                                          placeholder={ t('sign_up.form.security_question.placeholder') }
                                          defaultValue={intialValues.question}
                                          ref={register({ required: true, pattern: /^24/gi })} />
                                          <small className="form-text text-muted">{ ct('sign_up.form.security_question.text') }</small>
                                        { errorMessage(errors, 'question') }
                                      </div>
                										</div>

                										<div className="row justify-content-end">
                											<button type="submit" className="btn btn-primary btn-project">{ ct('sign_up.form.button') }</button>
                										</div>
                									</form>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
                  </Aux>
                }
                </div>

					</div>
				</div>
			</div>
  </Aux>
);
};

export default register;



// WEBPACK FOOTER //
// ./src/components/Auth/Register.js